import { RootState } from 'editor/src/store/index';

const getSpreadBackgroundImage = (state: RootState, spreadName: string) =>
  state.design.spreadBackgrounds?.find((background) => background.name === spreadName);

export default getSpreadBackgroundImage;
